import { render, staticRenderFns } from "./ReceiptApply.vue?vue&type=template&id=20571f09"
import script from "./ReceiptApply.vue?vue&type=script&lang=js"
export * from "./ReceiptApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports